module.exports = require("node:zlib");